<mat-card>
    <div class="action-container">
        <h2 class="table-title"> Legislative Groups</h2>

        <div class="search-container" color="primary">
            <app-search-bar #search (searchEvent)="applyFilter($event);" (clearSearchEvent)="clearFilter();"></app-search-bar>
        </div>
        
        <div class="action-buttons">
            <button mat-mini-fab color="primary" (click)="addGroup()" aria-label="Add New Legislation Group" matTooltip="Add Legislation Group">
                <mat-icon style="padding-right: 0; margin-right: 0">add</mat-icon>
                <!-- <span>Add</span> -->
            </button>
        </div>
    </div>

    <table mat-table [dataSource]="dataSource" [trackBy]="trackBy">
        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef style="width: 125px"></th>
            <td mat-cell *matCellDef="let group">
                <button mat-flat-button color="primary" (click)="editGroup(group)">Edit</button>
                <button mat-flat-button color="warn" (click)="deleteGroup(group)">Delete</button>
                <!-- <button mat-icon-button color="primary" [matMenuTriggerFor]="menu">
                    <mat-icon>more_vertical</mat-icon>
                </button>
                <mat-menu #menu="matMenu" style="width: 150px">
                    <button mat-menu-item (click)="editGroup(group)"><mat-icon color="primary">edit</mat-icon>Edit</button>
                <button mat-menu-item (click)="deleteGroup(group)"><mat-icon color="warn">delete</mat-icon>Delete</button>
                </mat-menu> -->
            </td>
        </ng-container>

        <!-- GroupName Column -->
        <ng-container matColumnDef="groupName">
            <th mat-header-cell *matHeaderCellDef>GroupName</th>
            <td mat-cell *matCellDef="let group">
                {{ group.groupName }} 
            </td>
        </ng-container>

        <!-- Total Recipients Column -->
        <ng-container matColumnDef="totalRecipients">
            <th mat-header-cell *matHeaderCellDef style="text-align: center; width: 120px">Total Members</th>
            <td mat-cell *matCellDef="let group" style="text-align: center; width: 120px">
                {{ group.recipientGroups.length }}
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay; let even = even" [class.evenRow]="even"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="columnsToDisplay.length">
                No groups matching the filter
                <span *ngIf="search.value"> "{{ search.value }}"</span>
            </td>
        </tr>
    </table>

    <div *ngIf="isLoading" style="padding: 1em">Loading data...</div>
</mat-card>